export const PILLAR_STICKER_ID = "PillarStickerId";
